import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** Without this, navigating from the footer to /terms keeps the old scroll offset and
 *  drops you into the middle of the document. */
export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // let anchor links (/#how) do their own thing
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}
